import { useBulkCheckCompleteToast } from '../useBulkCheckCompleteToast'

export default function BulkCheckCompleteToastHost() {
  useBulkCheckCompleteToast()
  return null
}
